import React from 'react'
import '../Styles/PrivacyPolicy.css'
const PrivacyPolicy = () => {
  return (
    <div className='PrivacyContainer'>
      <h1 className="text-center">Privacy Policy</h1>
      <p><strong>Last updated: 8, 17, 2023</strong></p>
      <br />
      {/* Section 1 */}
      <section id='sec_one'>
        <header class="major"><span style={{color:'#494949'}}><p><b> Introduction and Scope</b></p></span>&nbsp; </header>

        <p>
        Welcome to art-hub.us ("we," "us," or "our"). We value your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, disclose, and protect your personal data when you access and use our art platform (“Platform”). 
      Please read this Privacy Policy carefully to understand our practices regarding your personal information. By accessing or using our Platform, you consent to the practices described in this Privacy Policy.
        </p>
    
      </section>

{/* Section Two: Collected information */}
      <section id='sec_one'>
        <header class="major"><span style={{color:'#494949'}}><p><b>Section One: Collected information</b></p></span>&nbsp; </header>

        <p>
        <span>  
        Information You Provide: We collect information you provide directly when you register for an account, create a profile, upload artwork, and interact with other users. This information may include your name, email address, username, profile picture, biography, and any content you upload.
        </span>

<span>
Automatically Collected Information: We may collect certain information automatically when you use the Platform. This may include your IP address, device type, browser type, operating system, usage data, and other technical information.
</span>

<span>
Cookies and Tracking Technologies: We may use cookies and similar tracking technologies to enhance your experience on our Platform. Cookies are small data files stored on your device that help us recognize you when you return to the Platform. You can control how cookies are used through your browser settings.
</span>
        </p>
    
      </section>


{/* Usage informations */}
      <section id='sec_one'>
        <header class="major"><span style={{color:'#494949'}}><p><b>Section Two: How We Use Your Information</b></p></span>&nbsp; </header>

        <p>
        <span>  
        Provide and Improve the Platform: We use your information to operate, maintain, and improve our Platform, provide customer support and develop new features.
        </span>

<span>
Personalization: We may use your information to personalize your experience on the Platform, such as recommending artworks, artists, or content you might be interested in.
</span>

<span>
Communication: We may use your contact information to send you updates, newsletters, promotional materials, and other communications related to the Platform. You can opt-out of these communications at any time. 
</span>

<span>
Analyze Usage: We may analyze user behavior and usage patterns to improve the Platform's functionality and user experience.
</span>
      </p>    
      </section>


      {/* Information Sharing and Disclosure */}
      <section id='sec_one'>
        <header class="major"><span style={{color:'#494949'}}><p><b>Section Three: Information Sharing and Disclosure</b></p></span>&nbsp; </header>

        <p>
        <span>  
        Public Content: Any information or content you post on the Platform’s public areas, such as your profile, artwork, and comments, will be visible to other users. 
        </span>

<span>
Service Providers: We may share your information with third-party service providers who assist us in operating the Platform, such as hosting, data analysis, and customer support. 
</span>

<span>
Legal Compliance: We may disclose your information if required by law, court order, or governmental authority.
</span>

<span>
Protection of Rights: We may share information if we believe it is necessary to protect our rights, privacy, safety, or property, as well as the rights, privacy, safety, or property of our users or others.
</span>
      </p>    
      </section>


      {/* Data Security  */}
      <section id='sec_one'>
        <header class="major"><span style={{color:'#494949'}}><p><b>Section Four: Data Security </b></p></span>&nbsp; </header>

        <p>
        <span>  
        We take responsible measures to protect your personal information from unauthorized access, loss, misuse, or alteration. However, no method of transmission over the internet or electronic storage is entirely secure, so we cannot guarantee absolute security.
        </span>
 
      </p>    
      </section>

      {/* Data Security  */}
      <section id='sec_one'>
        <header class="major"><span style={{color:'#494949'}}><p><b>Section Five: Your Choices</b></p></span>&nbsp; </header>

        <p>
        <span>  
        You can review and update your account information at any time by logging into your account. You can also opt-out of receiving promotional emails from us.
        </span>
 
      </p>    
      </section>


      {/* Changes to this Privacy Policy */}
      <section id='sec_one'>
        <header class="major"><span style={{color:'#494949'}}><p><b>Section Six: Changes to this Privacy Policy</b></p></span>&nbsp; </header>

        <p>
        <span>  
        We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting the updated Privacy Policy on the Platform or by sending your an email.
        </span>
 
      </p>    
      </section>

      {/* Contact Us */}
      <section id='sec_one'>
        <header class="major"><span style={{color:'#494949'}}><p><b>Section Seven: Contact Us</b></p></span>&nbsp; </header>

        <p>
        <span>  
        If you have any questions or concerns about this Privacy Policy, please contact us at contact@art-hub.us. 

By using the Platform, you acknowledge that you have read and understood this Privacy Policy and consent to the practices described herein.
        </span>
 
      </p>    
      </section>
    </div>
  )
}

export default PrivacyPolicy